<!-- タブメニューコンポーネント -->

<script setup lang="ts">
  import { type ITabMenuItemInfo } from "~/interfaces/ITabMenuItemInfo";
  import { useHistoryStore } from "~/stores/HistoryStore";

  const historyStore = useHistoryStore();

  interface Emits {
    (event: "update:tab", tab: string): void;
  }

  interface Props {
    tab: string; // 選択されたタブのvalueが入る
    items: ITabMenuItemInfo[];
    vertical?: boolean;
  }
  const props = withDefaults(defineProps<Props>(), {
    vertical: false,
  });
  const emit = defineEmits<Emits>();
  const computedData = computed<string>({
    get: () => props.tab,
    set: value => {
      emit("update:tab", value);
    },
  });

  // タブの状態を保持できるように
  const route = useRoute();
  watch(
    () => route.query.tab,
    () => {
      if (route.query.tab) emit("update:tab", route.query.tab as string);
    },
  );
  onMounted(() => {
    if (route.query.tab) emit("update:tab", route.query.tab as string);
  });
  const onClickTab = (tabValue: string) => {
    const contentValue: Record<string, string> = {
      content: "live",
      member_list: "list",
    };
    const content = contentValue[tabValue] || "";
    const query = filterEmptyObject({
      ...route.query,
      tab: tabValue,
      content,
      showDetail: "",
      planId: "",
      dataVolume: "",
    });
    historyStore.to({ query }, { replace: true });
  };
</script>

<template>
  <div class="tab-wrapper bg-background" data-testid="tab-menu">
    <v-tabs
      v-if="computedData !== 'none'"
      v-model="computedData"
      bg-color="background"
      density="compact"
      height="48px"
      center-active
      :grow="true"
      slider-color="white"
      :show-arrows="true"
    >
      <MoleculesTabMenuItem
        v-for="item in items"
        :key="item.value"
        :value="item.value"
        :title="item.title"
        :count="item.count"
        :icon="item.icon"
        :vertical="vertical"
        @click="onClickTab(item.value)"
      />
    </v-tabs>
  </div>
</template>

<style lang="scss" scoped>
  .tab-wrapper {
    border-top: 1px solid rgb(var(--v-theme-monochrome-08));
    border-bottom: 1px solid rgb(var(--v-theme-monochrome-08));
    padding-top: 4px;
    padding-bottom: 4px;
  }

  :deep(.v-slide-group__prev) {
    display: none !important;
  }
  :deep(.v-slide-group__next) {
    background: rgba(0, 0, 0, 0.5) !important;
    position: absolute;
    height: 48px;
    top: 0%;
    right: 0%;
  }
  :deep(.v-slide-group__next--disabled) {
    display: none !important;
  }
</style>
